<!--
 * @Author: Hyman Choi
 * @Date: 2021-01-21 15:24:29
 * @LastEditTime: 2021-10-28 10:25:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\quizManagement\index.vue
-->
<template>
	<div class="app-container">
		<el-tabs type="border-card" v-model="tabName" style="margin-top: 20px;" v-tab-change:tabName="setActiveName">
			<!-- 问题列表 -->
			<el-tab-pane label="问题列表" name="list">
				<quizList />
			</el-tab-pane>
		
			<!-- 问答配置 -->
			<el-tab-pane label="问答配置" name="config">
				<quizConfig />
			</el-tab-pane>
			
		</el-tabs>
	</div>
</template>

<script>
	import quizConfig from "@/views/systemManagement/quizManagement/quizConfig"
	import quizList from "@/views/systemManagement/quizManagement/quizList"
	

	export default {
		data() {
			return {
				tabName: "list"
			}
		},
		components: {
			quizConfig,
			quizList
		},
	};
</script>

<style scoped lang="scss">
	
</style>
